/**
 * --------------------------------------------------------------------------
 * Bootstrap Pretty (0.2.2): index.esm.js
 * Licensed under Apache-2.0 (https://github.com/bootstrap-pretty/bootstrap-pretty/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

// Bootstrap
import Alert from './src/bootstrap/alert.js';
import Button from './src/bootstrap/button.js';
import Carousel from './src/bootstrap/carousel.js';
import Collapse from './src/bootstrap/collapse.js';
import Dropdown from './src/bootstrap/dropdown.js';
import Modal from './src/bootstrap/modal.js';
import Offcanvas from './src/bootstrap/offcanvas.js';
import Popover from './src/bootstrap/popover.js';
import ScrollSpy from './src/bootstrap/scrollspy.js';
import Tab from './src/bootstrap/tab.js';
import Toast from './src/bootstrap/toast.js';
import Tooltip from './src/bootstrap/tooltip.js';

// Bootstrap Pretty
import copyCodeSnippet from './src/copy-code-snippet.js';

export default {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip,
    copyCodeSnippet
};
